import React, { Fragment, useState } from 'react'
import { Container, Row, Col } from './Grid'
import Accordion from './Accordion'
import { motion } from 'framer-motion'
import { Dialog, Transition } from '@headlessui/react'

function ScheduleModal({ isOpen, setIsOpen }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog 
        as="div" 
        className="relative z-50" 
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-70" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[calc(100%-20px)] sm:w-[580px] md:w-[800px] lg:w-[1000px] xl:w-[1130px] transform">
                <div className="relative w-full h-[550px] sm:h-[600px] md:h-[700px] lg:h-[800px] xl:h-[850px]">
                  <iframe 
                    src="https://api.leadconnectorhq.com/widget/booking/1LipfM3jNUpGo9CehWOm" 
                    className="w-full h-full border-none"
                    scrolling="no"
                    id="Xw0C27hda3EIrsgdBbm5_1739264271721"
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default function Faq() {
  const [isScheduleOpen, setIsScheduleOpen] = useState(false)

  const faq = [
    {
      icon: `<svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.7665 1.60659L13.7545 1.59859L12.6972 0.887924C11.9714 0.399777 11.1056 0.162977 10.2324 0.213789C9.35923 0.264601 8.52677 0.600222 7.8625 1.16926L5.2665 3.39459C5.08519 3.54965 4.85441 3.63477 4.61584 3.63459H1.6665C1.40129 3.63459 1.14693 3.73995 0.959397 3.92748C0.771861 4.11502 0.666504 4.36937 0.666504 4.63459V12.6746C0.666504 13.2266 1.1145 13.6746 1.6665 13.6746H4.4505C4.5925 13.6745 4.73288 13.7047 4.86232 13.7631C4.99175 13.8215 5.10726 13.9067 5.20117 14.0133L8.31984 17.5599C8.80533 18.1117 9.47649 18.4661 10.206 18.5558C10.9354 18.6455 11.6724 18.4643 12.2772 18.0466L13.1892 17.4159L14.1678 17.7493C14.7726 17.9543 15.427 17.9611 16.0359 17.7685C16.6448 17.576 17.1763 17.1941 17.5532 16.6786L18.1798 15.8226L18.6145 15.8813C19.2165 15.9624 19.8289 15.8588 20.3708 15.5843C20.9127 15.3098 21.3585 14.8773 21.6492 14.3439L21.7145 14.2239H26.3332C26.5984 14.2239 26.8527 14.1186 27.0403 13.931C27.2278 13.7435 27.3332 13.4891 27.3332 13.2239V4.63592C27.3332 4.37071 27.2278 4.11635 27.0403 3.92882C26.8527 3.74128 26.5984 3.63592 26.3332 3.63592H23.3852C23.1453 3.636 22.9135 3.54987 22.7318 3.39326L20.4798 1.44792C19.5405 0.636232 18.3328 0.203027 17.0916 0.232601C15.8505 0.262175 14.6648 0.752411 13.7652 1.60792M11.5785 2.54792L12.3278 3.05192L9.7145 5.67992C9.43286 5.96317 9.21061 6.29981 9.06081 6.6701C8.911 7.04038 8.83665 7.43686 8.84211 7.83626C8.84758 8.23566 8.93275 8.62996 9.09263 8.99601C9.25251 9.36205 9.48388 9.69249 9.77317 9.96792L9.86384 10.0533C10.9438 11.0813 12.6132 11.1613 13.7852 10.2399L16.5572 8.06392L20.0998 11.4706C20.2581 11.6226 20.362 11.8224 20.3955 12.0392C20.429 12.2561 20.3902 12.4779 20.2852 12.6706L20.2518 12.7293L20.2332 12.7639L19.8932 13.3866C19.7963 13.5641 19.6478 13.7081 19.4673 13.7995C19.2869 13.8909 19.083 13.9255 18.8825 13.8986L17.8572 13.7613C17.679 13.7373 17.4977 13.7618 17.3322 13.8322C17.1668 13.9026 17.0234 14.0162 16.9172 14.1613L15.9385 15.4973C15.813 15.6691 15.6359 15.7964 15.433 15.8607C15.2302 15.9249 15.0121 15.9228 14.8105 15.8546L13.3572 15.3613C13.2093 15.3109 13.0518 15.296 12.8971 15.3175C12.7424 15.339 12.595 15.3965 12.4665 15.4853L11.1412 16.4013C10.9395 16.5407 10.6936 16.6012 10.4502 16.5712C10.2068 16.5412 9.98298 16.4228 9.82117 16.2386L6.7025 12.6919C6.42076 12.372 6.07406 12.1158 5.68551 11.9403C5.29696 11.7649 4.87548 11.6743 4.44917 11.6746H2.6665V5.63459H4.6145C5.3304 5.63475 6.02275 5.3789 6.5665 4.91326L9.16384 2.68792C9.49589 2.40331 9.91209 2.23537 10.3487 2.20985C10.7853 2.18432 11.2182 2.30261 11.5812 2.54659M22.4078 12.2253C22.4127 11.8156 22.3335 11.4093 22.1753 11.0314C22.0171 10.6535 21.7831 10.312 21.4878 10.0279L18.1265 6.79592C18.2774 6.60359 18.3526 6.36266 18.3379 6.11866C18.3232 5.87466 18.2196 5.64449 18.0468 5.47165C17.8739 5.2988 17.6438 5.19525 17.3998 5.18056C17.1558 5.16587 16.9148 5.24106 16.7225 5.39192L16.0478 5.92126L15.9678 5.98392L12.5518 8.66792C12.3627 8.81652 12.1264 8.89198 11.8862 8.88047C11.6459 8.86896 11.4179 8.77125 11.2438 8.60526L11.1532 8.51859C11.0567 8.42681 10.9796 8.31669 10.9262 8.19469C10.8729 8.07269 10.8445 7.94126 10.8426 7.80813C10.8407 7.67499 10.8655 7.54283 10.9154 7.41938C10.9653 7.29594 11.0393 7.1837 11.1332 7.08926L15.0865 3.11592C15.6219 2.57768 16.3414 2.26243 17.1001 2.23372C17.8587 2.20502 18.6 2.465 19.1745 2.96126L21.4238 4.90526C21.9692 5.37619 22.6659 5.63508 23.3865 5.63459H25.3332V12.2253H22.4078Z" fill="currentColor"/>
          </svg>
          `,
      title: 'Strategic Partnership',
      faq: [
        {
          title: 'What makes Train & Scale different from other business consulting firms?',
          body: `<p>We're not just consultants – we're your strategic growth partners. Our team provides end-to-end support with proven systems, dedicated sales management, and strategic funding options. We understand that each business is unique, which is why we first assess your specific situation to determine the best path forward, whether you're starting fresh or looking to scale.</p>`,
        },
        {
          title: 'Why explore funding options before starting?',
          body: `<p>Smart business growth starts with understanding all your options. Before investing your own capital, we help you explore available funding opportunities ($30K-$5M) based on both your personal and business metrics. This strategic approach ensures you're leveraging the best possible resources for maximum growth potential.</p>`,
        },
        {
          title: 'How does our system support business exits?',
          body: `<p>Our system is specifically designed with exit potential in mind. We implement clear data metrics, scalable processes, and proven frameworks that make your business attractive to investors. Whether you're the face of the company or prefer to use our professional team, we build systems that can operate independently and profitably.</p>`,
        },
      ]
    },
    {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
          <path d="M25.6664 2.99773V8.33106M28.3331 5.6644H22.9998M4.33309 21.6644V24.3311M5.66642 22.9977H2.99976M12.2491 19.6644C12.1301 19.203 11.8895 18.7819 11.5526 18.4449C11.2156 18.1079 10.7945 17.8674 10.3331 17.7484L2.15309 15.6391C2.01353 15.5994 1.8907 15.5154 1.80324 15.3997C1.71578 15.2839 1.66846 15.1428 1.66846 14.9977C1.66846 14.8527 1.71578 14.7115 1.80324 14.5958C1.8907 14.4801 2.01353 14.396 2.15309 14.3564L10.3331 12.2457C10.7944 12.1268 11.2153 11.8865 11.5523 11.5498C11.8892 11.2131 12.1298 10.7922 12.2491 10.3311L14.3584 2.15106C14.3976 2.01095 14.4816 1.88752 14.5975 1.79959C14.7134 1.71166 14.8549 1.66406 15.0004 1.66406C15.1459 1.66406 15.2874 1.71166 15.4033 1.79959C15.5192 1.88752 15.6032 2.01095 15.6424 2.15106L17.7504 10.3311C17.8695 10.7925 18.11 11.2136 18.4469 11.5506C18.7839 11.8875 19.205 12.128 19.6664 12.2471L27.8464 14.3551C27.9871 14.3939 28.1111 14.4777 28.1995 14.5938C28.2879 14.7099 28.3358 14.8518 28.3358 14.9977C28.3358 15.1436 28.2879 15.2855 28.1995 15.4016C28.1111 15.5177 27.9871 15.6016 27.8464 15.6404L19.6664 17.7484C19.205 17.8674 18.7839 18.1079 18.4469 18.4449C18.11 18.7819 17.8695 19.203 17.7504 19.6644L15.6411 27.8444C15.6019 27.9845 15.5179 28.1079 15.402 28.1959C15.2861 28.2838 15.1446 28.3314 14.9991 28.3314C14.8536 28.3314 14.7121 28.2838 14.5962 28.1959C14.4803 28.1079 14.3963 27.9845 14.3571 27.8444L12.2491 19.6644Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
          `,
      title: 'Implementation & Support',
      faq: [
        {
          title: 'What ongoing support do you provide?',
          body: `<p>Our partnership includes dedicated sales management, weekly consulting calls, and continuous optimization of your systems. We're here to help you navigate every aspect of growth, from funding to scaling, ensuring you have the support needed to achieve your business goals.</p>`,
        },
        {
          title: 'How customizable are your solutions?',
          body: `<p>Whether you want to be the face of your company or prefer our professional team to handle operations, we adapt our systems to your needs. We can help you build a business that's both profitable now and attractive for future exit opportunities.</p>`,
        },
      ]
    },
  ]
  const faq2 = [
    {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path d="M22.3319 2.66406H28.4039L28.5373 2.68273L28.6693 2.72006L28.7493 2.75473C28.8559 2.80095 28.9533 2.86762 29.0413 2.95473L29.0946 3.0134L29.1533 3.0894L29.2253 3.2094L29.2773 3.3294L29.3026 3.41473L29.3213 3.50006L29.3333 3.62673V9.6694C29.3332 9.92276 29.237 10.1667 29.064 10.3518C28.891 10.5369 28.6542 10.6495 28.4014 10.6668C28.1487 10.684 27.8988 10.6047 27.7022 10.4448C27.5057 10.2849 27.3772 10.0564 27.3426 9.8054L27.3333 9.6694V6.07606L18.7466 14.6627C18.5773 14.8321 18.3528 14.9351 18.114 14.9529C17.8752 14.9708 17.6379 14.9023 17.4453 14.7601L17.3333 14.6641L13.2933 10.7841L5.70661 18.3694C5.52818 18.5483 5.28863 18.6531 5.03612 18.6626C4.7836 18.6721 4.53686 18.5856 4.34549 18.4206C4.15413 18.2556 4.03233 18.0242 4.00458 17.7731C3.97684 17.5219 4.04521 17.2695 4.19595 17.0667L4.29328 16.9547L12.5866 8.6614C12.7561 8.49224 12.9807 8.38951 13.2195 8.3719C13.4583 8.35428 13.6955 8.42294 13.8879 8.5654L13.9999 8.6614L18.0399 12.5414L25.9173 4.66406H22.3306C22.0892 4.66373 21.856 4.57607 21.6742 4.41727C21.4924 4.25847 21.3741 4.03924 21.3413 3.80006L21.3319 3.66406C21.332 3.42241 21.4195 3.18894 21.5783 3.00682C21.7371 2.8247 21.9565 2.70626 22.1959 2.6734L22.3319 2.66406ZM4.99995 22.6641C5.26516 22.6641 5.51952 22.7694 5.70705 22.957C5.89459 23.1445 5.99995 23.3988 5.99995 23.6641V28.3307C5.99995 28.5959 5.89459 28.8503 5.70705 29.0378C5.51952 29.2254 5.26516 29.3307 4.99995 29.3307C4.73473 29.3307 4.48038 29.2254 4.29284 29.0378C4.1053 28.8503 3.99995 28.5959 3.99995 28.3307V23.6641C3.99995 23.3988 4.1053 23.1445 4.29284 22.957C4.48038 22.7694 4.73473 22.6641 4.99995 22.6641ZM12.6666 18.3307C12.6666 18.0655 12.5613 17.8112 12.3737 17.6236C12.1862 17.4361 11.9318 17.3307 11.6666 17.3307C11.4014 17.3307 11.147 17.4361 10.9595 17.6236C10.772 17.8112 10.6666 18.0655 10.6666 18.3307V28.3307C10.6666 28.5959 10.772 28.8503 10.9595 29.0378C11.147 29.2254 11.4014 29.3307 11.6666 29.3307C11.9318 29.3307 12.1862 29.2254 12.3737 29.0378C12.5613 28.8503 12.6666 28.5959 12.6666 28.3307V18.3307ZM18.3333 19.9974C18.5985 19.9974 18.8529 20.1028 19.0404 20.2903C19.2279 20.4778 19.3333 20.7322 19.3333 20.9974V28.3307C19.3333 28.5959 19.2279 28.8503 19.0404 29.0378C18.8529 29.2254 18.5985 29.3307 18.3333 29.3307C18.0681 29.3307 17.8137 29.2254 17.6262 29.0378C17.4386 28.8503 17.3333 28.5959 17.3333 28.3307V20.9974C17.3333 20.7322 17.4386 20.4778 17.6262 20.2903C17.8137 20.1028 18.0681 19.9974 18.3333 19.9974ZM26 14.3307C26 14.0655 25.8946 13.8112 25.7071 13.6236C25.5195 13.4361 25.2652 13.3307 24.9999 13.3307C24.7347 13.3307 24.4804 13.4361 24.2928 13.6236C24.1053 13.8112 23.9999 14.0655 23.9999 14.3307V28.3307C23.9999 28.5959 24.1053 28.8503 24.2928 29.0378C24.4804 29.2254 24.7347 29.3307 24.9999 29.3307C25.2652 29.3307 25.5195 29.2254 25.7071 29.0378C25.8946 28.8503 26 28.5959 26 28.3307V14.3307Z" fill="currentColor"/>
            </svg>
          `,
      title: 'Growth & Scaling',
      faq: [
        {
          title: 'How do you approach business scaling?',
          body: `<p>We've developed a multi-faceted system that works across various high-ticket niches. Our approach includes strategic funding, professional online presence development, and comprehensive sales systems. We can either train your team or provide our own experts, ensuring consistent growth and profitability.</p>`,
        },
        {
          title: 'What makes now the right time to act?',
          body: `<p class="pb-3">With the rise of AI and rapidly evolving market conditions, the current opportunity window is unique. Our systems leverage cutting-edge technology and proven strategies to help you capitalize on these changes. Early adopters of our comprehensive approach are seeing exceptional results in market positioning and growth potential.</p>`,
        },
      ]
    },
  ]

  const actionButtons = [
    {
      title: "Schedule Strategy Call",
      subtitle: "Discuss Your Growth Plans",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>`,
      color: "#2563EB"
    },
    {
      title: "Set a Reminder",
      subtitle: "Get a Quick SMS Reminder",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>`,
      color: "#3B82F6"
    }
  ]

  const ActionButtons = () => {
    return (
      <div className="max-w-[600px] mx-auto mt-12" data-aos="fade-up" data-aos-delay="1000">
        <div className="relative bg-white/80 backdrop-blur-lg rounded-3xl p-8 shadow-lg">
          <div className="absolute inset-0 bg-gradient-to-br from-[#E0EDFE]/50 to-white/30 rounded-3xl"></div>
          
          <div className="relative">
            <h4 className="text-2xl font-semibold text-gray-800 mb-8 text-center">
              Take The Next Step
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {actionButtons.map((button, index) => (
                <motion.button
                  key={index}
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: index * 0.2 }}
                  className="relative group w-full"
                  style={{ color: button.color }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => button.title === "Schedule Strategy Call" ? setIsScheduleOpen(true) : null}
                >
                  <div className="relative p-6 text-center border-2 rounded-xl group-hover:border-current transition-colors duration-300">
                    <div className="flex justify-center mb-4">
                      <div className="w-12 h-12 rounded-full flex items-center justify-center border-2 border-current">
                        <div dangerouslySetInnerHTML={{ __html: button.icon }}></div>
                      </div>
                    </div>
                    
                    <h5 className="text-xl font-semibold mb-2">
                      {button.title}
                    </h5>
                    
                    <p className="text-sm text-gray-600">
                      {button.subtitle}
                    </p>
                  </div>
                </motion.button>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="faq common-padding relative z-[1] bg-gradient-to-r from-[#E0EDFE] to-[rgba(224,_237,_254,_0)]">
        <Container>
          <Row className="justify-center">
            <Col xs={12} lg={8}>
              <div className="common-title text-center">
                <span 
                  className='tracking-[2.4px] !leading-[150%] text-[#2563EB] mb-2 xl:mb-3 font-medium inline-flex items-center justify-center gap-2' 
                  data-aos="fade-up" 
                  data-aos-delay="200"
                >
                  <svg className="w-4 h-4" viewBox="0 0 16 16" fill="none">
                    <path d="M8 1.5V3M8 13V14.5M14.5 8H13M3 8H1.5M12.5 12.5L11.5 11.5M12.5 3.5L11.5 4.5M3.5 12.5L4.5 11.5M3.5 3.5L4.5 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                  THE MOMENT TO SCALE IS NOW
                </span>
                
                <h2 
                  className="mb-6 text-[#1F2937]"
                  data-aos="fade-up" 
                  data-aos-delay="400"
                >
                  Got Questions? Let's Clear the Path Forward
                </h2>

                <div 
                  className="flex flex-col items-center gap-6 max-w-[650px] mx-auto mb-12"
                  data-aos="fade-up" 
                  data-aos-delay="600"
                >
                  <p className='text-[#4B5563] text-lg leading-relaxed'>
                    We've focused on the key questions that matter most when scaling your business. Get straight answers about our approach, process, and how we can help you reach your growth goals.
                  </p>
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              {faq.map((item, index) => (
                <div key={index} className='mb-5 lg:mb-8' data-aos="fade-up" data-aos-delay={`${index + 3}00`}>
                  <div className="flex items-center gap-4 xl:gap-[20px] mb-5 lg:mb-8 group">
                    <div className={`size-12  xl:size-[56px] rounded-full border flex items-center justify-center bg-transparent transition-all duration-700  group-hover:bg-white group-hover:text-primary group-hover:border-0`}>
                      <div dangerouslySetInnerHTML={{ __html: item.icon }} className='icon'></div>
                    </div>
                    <h4 className='text-xl md:text-2xl xl:text-[31px] font-semibold !leading-[140%] text-[#1F2937]'>{item.title} </h4>
                  </div>
                  <Accordion items={item.faq} />
                </div>
              ))}
            </Col>
            <Col xs={12} lg={6}>
              {faq2.map((item, index) => (
                <div key={index} className='mb-5 lg:mb-8' data-aos="fade-up" data-aos-delay={`${index + 9}00`}>
                  <div className="flex items-center group gap-4 xl:gap-[20px] mb-5 lg:mb-8">
                    <div className={`size-12  xl:size-[56px] rounded-full border flex items-center justify-center bg-transparent transition-all duration-700  group-hover:bg-white group-hover:text-primary group-hover:border-0`}>
                      <div dangerouslySetInnerHTML={{ __html: item.icon }} className='icon '></div>
                    </div>
                    <h4 className='text-xl md:text-2xl xl:text-[31px] font-semibold !leading-[140%] text-[#1F2937]'>{item.title} </h4>
                  </div>
                  <Accordion items={item.faq} />
                </div>
              ))}
              <ActionButtons />
            </Col>
          </Row>
        </Container>
      </div>
      <ScheduleModal isOpen={isScheduleOpen} setIsOpen={setIsScheduleOpen} />
    </>
  )
}